// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Url } from 'src/url/url'

// const PERMISSION_GROUPS = [
//   { group: 'Dashboard',           key: 'dashboard',          items: [{ label: 'View Dashboard', key: 'view' }] },
//   { group: 'Order Detail',        key: 'orderDetail',        items: [{ label: 'New Projects', key: 'newProjects' }, { label: 'Running Projects', key: 'runningProjects' }, { label: 'Complete Projects', key: 'completeProjects' }, { label: 'Refund Project', key: 'refundProject' }] },
//   { group: 'Team',                key: 'team',               items: [{ label: 'Staff', key: 'staff' }, { label: 'Freelancers', key: 'freelancers' }] },
//   { group: 'Services',            key: 'services',           items: [{ label: 'Category', key: 'category' }, { label: 'Subcategory', key: 'subcategory' }, { label: 'Package', key: 'package' }, { label: 'Project', key: 'project' }, { label: 'Combo Services', key: 'comboServices' }] },
//   { group: 'Client',              key: 'client',             items: [{ label: 'View Client', key: 'view' }] },
//   { group: 'Chat',                key: 'chat',               items: [{ label: 'View Chat', key: 'view' }] },
//   { group: 'Coupon',              key: 'coupon',             items: [{ label: 'View Coupon', key: 'view' }] },
//   { group: 'Icons Format',        key: 'iconsFormat',        items: [{ label: 'Icons Format', key: 'iconsFormat' }, { label: 'Bulk Email Images', key: 'bulkEmailImages' }] },
//   { group: 'Staff Role',          key: 'staffRole',          items: [{ label: 'View Staff Role', key: 'view' }] },
//   { group: 'Rating',              key: 'rating',             items: [{ label: 'View Rating', key: 'view' }] },
//   { group: 'Blog',                key: 'blog',               items: [{ label: 'View Blog', key: 'view' }] },
//   { group: 'Help Support',        key: 'helpSupport',        items: [{ label: 'View Help Support', key: 'view' }] },
//   { group: 'Bulk Mailing',        key: 'bulkMailing',        items: [{ label: 'View Bulk Mailing', key: 'view' }] },
//   { group: 'Management Settings', key: 'managementSettings', items: [{ label: 'Add Staff', key: 'addStaff' }, { label: 'Permissions', key: 'permissions' }] },
// ]

// const TOTAL_PERMS = PERMISSION_GROUPS.reduce((a, g) => a + g.items.length, 0)

// const buildInitialState = () => {
//   const state = {}
//   PERMISSION_GROUPS.forEach(g => {
//     state[g.key] = {}
//     g.items.forEach(item => { state[g.key][item.key] = false })
//   })
//   return state
// }

// const mergePermissions = (serverPerms) => {
//   const base = buildInitialState()
//   if (!serverPerms) return base
//   PERMISSION_GROUPS.forEach(g => {
//     if (serverPerms[g.key]) {
//       g.items.forEach(item => {
//         if (typeof serverPerms[g.key][item.key] === 'boolean') {
//           base[g.key][item.key] = serverPerms[g.key][item.key]
//         }
//       })
//     }
//   })
//   return base
// }

// const countSelected = (perms) =>
//   Object.values(perms).flatMap(g => Object.values(g)).filter(Boolean).length

// const Permissions = () => {
//   const [roles, setRoles]                 = useState([])
//   const [savedPermsMap, setSavedPermsMap] = useState({})
//   const [selectedRole, setSelectedRole]   = useState(null)
//   const [permissions, setPermissions]     = useState(buildInitialState)
//   const [saving, setSaving]               = useState(false)
//   const [toast, setToast]                 = useState(null)

//   const showToast = (msg, type = 'success') => {
//     setToast({ msg, type })
//     setTimeout(() => setToast(null), 3000)
//   }

//   // ── Role ki permissions fetch karo ───────────────────────────
//   const loadPermissionForRole = async (roleId) => {
//     const key = roleId.toString()
//     try {
//       const res = await axios.get(`${Url}/permissions/${key}`)
//       const serverPerms = res.data?.data?.permissions || null
//       if (serverPerms) {
//         setSavedPermsMap(prev => ({ ...prev, [key]: serverPerms }))
//         return serverPerms
//       }
//     } catch (err) {
//       // permissions nahi hain — normal hai
//     }
//     return null
//   }

//   // ── Sabhi roles fetch karo + sabhi ki permissions bhi ────────
//   useEffect(() => {
//     const init = async () => {
//       try {
//         const res = await axios.get(`${Url}/role`)
//         const roleList = res.data || []
//         setRoles(roleList)

//         if (roleList.length === 0) return

//         // Sabhi roles ki permissions ek saath fetch karo
//         const results = await Promise.allSettled(
//           roleList.map(r =>
//             axios.get(`${Url}/permissions/${r._id.toString()}`)
//               .then(res => ({ roleId: r._id.toString(), perms: res.data?.data?.permissions || null }))
//               .catch(() => ({ roleId: r._id.toString(), perms: null }))
//           )
//         )

//         // savedPermsMap ek baar mein build karo
//         const map = {}
//         results.forEach(result => {
//           if (result.status === 'fulfilled' && result.value.perms) {
//             map[result.value.roleId] = result.value.perms
//           }
//         })
//         setSavedPermsMap(map)

//         // Pehla role select karo
//         const firstRole = roleList[0]
//         setSelectedRole(firstRole)
//         setPermissions(mergePermissions(map[firstRole._id.toString()] || null))

//       } catch (err) {
//         console.error('Init error:', err)
//       }
//     }
//     init()
//   }, [])

//   // ── Role click ────────────────────────────────────────────────
//   const handleRoleSelect = (role) => {
//     const key = role._id.toString()
//     setSelectedRole(role)
//     setPermissions(mergePermissions(savedPermsMap[key] || null))
//   }

//   // ── Checkbox handlers ─────────────────────────────────────────
//   const toggleItem = (groupKey, itemKey) =>
//     setPermissions(prev => ({
//       ...prev,
//       [groupKey]: { ...prev[groupKey], [itemKey]: !prev[groupKey][itemKey] },
//     }))

//   const toggleGroup = (groupKey, items) => {
//     const allChecked = items.every(i => permissions[groupKey][i.key])
//     const updated = {}
//     items.forEach(i => { updated[i.key] = !allChecked })
//     setPermissions(prev => ({ ...prev, [groupKey]: updated }))
//   }

//   const selectAll = (val) => {
//     const state = {}
//     PERMISSION_GROUPS.forEach(g => {
//       state[g.key] = {}
//       g.items.forEach(item => { state[g.key][item.key] = val })
//     })
//     setPermissions(state)
//   }

//   const isGroupChecked = (groupKey, items) => items.every(i => permissions[groupKey][i.key])
//   const isGroupPartial = (groupKey, items) =>
//     items.some(i => permissions[groupKey][i.key]) && !isGroupChecked(groupKey, items)

//   const totalSelected = () => countSelected(permissions)
//   const hasExisting = selectedRole ? !!savedPermsMap[selectedRole._id.toString()] : false

//   // ── Save / Update ─────────────────────────────────────────────
//   const handleSubmit = async () => {
//     if (!selectedRole) return showToast('Role select karein!', 'error')
//     setSaving(true)
//     try {
//       const payload = {
//         roleId: selectedRole._id,
//         roleName: selectedRole.role,
//         permissions,
//       }
//       await axios.post(`${Url}/permissions`, payload)
//       // Local map update karo
//       setSavedPermsMap(prev => ({ ...prev, [selectedRole._id.toString()]: permissions }))
//       showToast(`"${selectedRole.role}" ki permissions ${hasExisting ? 'update' : 'save'} ho gayi! ✓`)
//     } catch (err) {
//       showToast('Error aaya, dobara try karein!', 'error')
//     } finally {
//       setSaving(false)
//     }
//   }

//   // ── Delete ────────────────────────────────────────────────────
//   const handleDelete = async () => {
//     if (!selectedRole) return
//     if (!window.confirm(`"${selectedRole.role}" ki permissions delete karein?`)) return
//     try {
//       await axios.delete(`${Url}/permissions/${selectedRole._id}`)
//       setSavedPermsMap(prev => {
//         const updated = { ...prev }
//         delete updated[selectedRole._id.toString()]
//         return updated
//       })
//       setPermissions(buildInitialState())
//       showToast(`"${selectedRole.role}" ki permissions delete ho gayi!`, 'error')
//     } catch (err) {
//       showToast('Delete mein error!', 'error')
//     }
//   }

//   return (
//     <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', background: '#f8fafc' }}>

//       {/* ── Toast ── */}
//       {toast && (
//         <div style={{
//           position: 'fixed', top: 20, right: 20, zIndex: 9999,
//           padding: '12px 20px', borderRadius: 10, fontSize: 13, fontWeight: 600,
//           background: toast.type === 'error' ? '#fef2f2' : '#f0fdf4',
//           color: toast.type === 'error' ? '#dc2626' : '#16a34a',
//           border: `1px solid ${toast.type === 'error' ? '#fecaca' : '#bbf7d0'}`,
//           boxShadow: '0 4px 12px rgba(0,0,0,.1)',
//         }}>
//           {toast.type === 'error' ? '❌' : '✅'} {toast.msg}
//         </div>
//       )}

//       {/* ════════════════════════
//           LEFT — Roles List
//       ════════════════════════ */}
//       <div style={{ width: 240, background: 'white', borderRight: '1px solid #e2e8f0', padding: '24px 0', flexShrink: 0 }}>
//         <div style={{ padding: '0 16px 16px', borderBottom: '1px solid #f1f5f9' }}>
//           <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}> All Roles</h3>
//           <p style={{ margin: '4px 0 0', fontSize: 11, color: '#94a3b8' }}>{roles.length} roles total</p>
//         </div>

//         <div style={{ padding: '8px 0' }}>
//           {roles.length === 0 ? (
//             <p style={{ padding: '12px 16px', fontSize: 13, color: '#94a3b8' }}>Loading...</p>
//           ) : (
//             roles.map(r => {
//               const key      = r._id.toString()
//               const isActive = selectedRole?._id.toString() === key
//               const isSet    = !!savedPermsMap[key]
//               const setCount = isSet ? countSelected(mergePermissions(savedPermsMap[key])) : 0

//               return (
//                 <div
//                   key={key}
//                   onClick={() => handleRoleSelect(r)}
//                   style={{
//                     padding: '10px 16px', cursor: 'pointer',
//                     background: isActive ? '#eff6ff' : 'transparent',
//                     borderLeft: `3px solid ${isActive ? '#1e40af' : 'transparent'}`,
//                     transition: 'all 0.15s',
//                   }}
//                 >
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                     <span style={{
//                       fontSize: 13, fontWeight: isActive ? 700 : 500,
//                       color: isActive ? '#1e40af' : '#334155',
//                       textTransform: 'capitalize',
//                     }}>
//                       {r.role}
//                     </span>
//                     <span style={{
//                       fontSize: 10, padding: '2px 7px', borderRadius: 10, fontWeight: 600,
//                       background: isSet ? '#f0fdf4' : '#fef9c3',
//                       color: isSet ? '#16a34a' : '#92400e',
//                       border: `1px solid ${isSet ? '#bbf7d0' : '#fde68a'}`,
//                     }}>
//                       {isSet ? '✓ Set' : 'Pending'}
//                     </span>
//                   </div>

//                   {isSet && (
//                     <div style={{ marginTop: 6 }}>
//                       <div style={{ height: 4, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
//                         <div style={{
//                           height: '100%',
//                           width: `${(setCount / TOTAL_PERMS) * 100}%`,
//                           background: '#1e40af', borderRadius: 4,
//                         }} />
//                       </div>
//                       <span style={{ fontSize: 10, color: '#94a3b8', marginTop: 2, display: 'block' }}>
//                         {setCount}/{TOTAL_PERMS} permissions
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               )
//             })
//           )}
//         </div>
//       </div>

//       {/* ════════════════════════
//           RIGHT — Editor
//       ════════════════════════ */}
//       <div style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>

//         {/* Header */}
//         <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <div>
//             <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1e293b' }}>
//               {selectedRole
//                 ? <>Permissions — <span style={{ color: '#1e40af', textTransform: 'capitalize' }}>{selectedRole.role}</span></>
//                 : 'Permissions'}
//             </h2>
//             <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
//               {hasExisting ? '✏️ Edit mode — permissions pehle se set hain' : '🆕 Naye permissions set karein'}
//             </p>
//           </div>
//           {hasExisting && (
//             <span style={{ fontSize: 12, padding: '5px 14px', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 20, fontWeight: 600 }}>
//               ✓ Already Configured
//             </span>
//           )}
//         </div>

//         {/* Actions Bar */}
//         <div style={{ background: 'white', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,.05)' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: '#64748b' }}>
//             <span style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{totalSelected()}</span>
//             <span>/ {TOTAL_PERMS} selected</span>
//             <div style={{ width: 100, height: 6, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
//               <div style={{ height: '100%', width: `${(totalSelected() / TOTAL_PERMS) * 100}%`, background: '#1e40af', borderRadius: 4, transition: 'width 0.2s' }} />
//             </div>
//           </div>
//           <div style={{ display: 'flex', gap: 8 }}>
//             <button onClick={() => selectAll(true)}
//               style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: 7, cursor: 'pointer' }}>
//               ✓ All
//             </button>
//             <button onClick={() => selectAll(false)}
//               style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: 7, cursor: 'pointer' }}>
//               ✕ None
//             </button>
//             {hasExisting && (
//               <button onClick={handleDelete}
//                 style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 7, cursor: 'pointer' }}>
//                 🗑 Delete
//               </button>
//             )}
//             <button onClick={handleSubmit} disabled={saving || !selectedRole}
//               style={{ padding: '6px 20px', fontSize: 12, fontWeight: 700, background: saving || !selectedRole ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 7, cursor: saving ? 'not-allowed' : 'pointer' }}>
//               {saving ? '⏳...' : hasExisting ? '✏️ Update' : '💾 Save'}
//             </button>
//           </div>
//         </div>

//         {/* No role selected */}
//         {!selectedRole ? (
//           <div style={{ textAlign: 'center', padding: 80, color: '#94a3b8' }}>
//             <div style={{ fontSize: 40, marginBottom: 12 }}>👈</div>
//             <p style={{ fontSize: 14 }}>Left side se koi role select karein</p>
//           </div>
//         ) : (
//           <>
//             {/* Permission Groups Grid */}
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
//               {PERMISSION_GROUPS.map(({ group, key: groupKey, items }) => {
//                 const allChecked     = isGroupChecked(groupKey, items)
//                 const partialChecked = isGroupPartial(groupKey, items)
//                 return (
//                   <div key={groupKey} style={{ background: 'white', borderRadius: 12, border: `1px solid ${allChecked ? '#bfdbfe' : '#e2e8f0'}`, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,.04)' }}>
//                     <div
//                       onClick={() => toggleGroup(groupKey, items)}
//                       style={{ padding: '11px 14px', background: allChecked ? '#eff6ff' : partialChecked ? '#fefce8' : '#f8fafc', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
//                     >
//                       <input
//                         type="checkbox" checked={allChecked}
//                         ref={el => { if (el) el.indeterminate = partialChecked }}
//                         onChange={() => toggleGroup(groupKey, items)}
//                         onClick={e => e.stopPropagation()}
//                         style={{ width: 15, height: 15, cursor: 'pointer', accentColor: '#1e40af' }}
//                       />
//                       <span style={{ fontSize: 13, fontWeight: 700, color: '#1e293b', flex: 1 }}>{group}</span>
//                       <span style={{ fontSize: 11, color: allChecked ? '#1e40af' : partialChecked ? '#92400e' : '#94a3b8', fontWeight: 600 }}>
//                         {items.filter(i => permissions[groupKey][i.key]).length}/{items.length}
//                       </span>
//                     </div>
//                     <div style={{ padding: '6px 14px 10px' }}>
//                       {items.map(({ label, key: itemKey }) => (
//                         <label key={itemKey}
//                           style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', cursor: 'pointer', borderBottom: '1px solid #f1f5f9' }}>
//                           <input
//                             type="checkbox"
//                             checked={permissions[groupKey][itemKey]}
//                             onChange={() => toggleItem(groupKey, itemKey)}
//                             style={{ width: 14, height: 14, cursor: 'pointer', accentColor: '#1e40af' }}
//                           />
//                           <span style={{ fontSize: 13, color: permissions[groupKey][itemKey] ? '#1e293b' : '#64748b', fontWeight: permissions[groupKey][itemKey] ? 500 : 400 }}>
//                             {label}
//                           </span>
//                           {permissions[groupKey][itemKey] && (
//                             <span style={{ marginLeft: 'auto', fontSize: 10, color: '#16a34a', fontWeight: 700 }}>✓</span>
//                           )}
//                         </label>
//                       ))}
//                     </div>
//                   </div>
//                 )
//               })}
//             </div>

//             {/* Bottom Save */}
//             <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
//               {hasExisting && (
//                 <button onClick={handleDelete}
//                   style={{ padding: '10px 24px', fontSize: 14, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, cursor: 'pointer' }}>
//                   🗑 Delete Permissions
//                 </button>
//               )}
//               <button onClick={handleSubmit} disabled={saving || !selectedRole}
//                 style={{ padding: '10px 32px', fontSize: 14, fontWeight: 700, background: saving ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 8, cursor: saving ? 'not-allowed' : 'pointer' }}>
//                 {saving ? '⏳ Saving...' : hasExisting ? '✏️ Update Permissions' : '💾 Save Permissions'}
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

// export default Permissions










// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Url } from 'src/url/url'

// const PERMISSION_GROUPS = [
//   { group: 'Dashboard',           key: 'dashboard',          items: [{ label: 'View', key: 'view' }] },
//   { group: 'New Projects',        key: 'newProjects',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Running Projects',    key: 'runningProjects',    items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Complete Projects',   key: 'completeProjects',   items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Refund Project',      key: 'refundProject',      items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Team',                key: 'team',               items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Services',            key: 'services',           items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Category',            key: 'category',           items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Subcategory',         key: 'subcategory',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Package',             key: 'package',            items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Project',             key: 'project',            items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Combo Services',      key: 'comboServices',      items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Client',              key: 'client',             items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Chat',                key: 'chat',               items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Coupon',              key: 'coupon',             items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Icons Format',        key: 'iconsFormat',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }, { label: 'Bulk Email Images', key: 'bulkEmailImages' }] },
//   { group: 'Staff Role',          key: 'staffRole',          items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Rating',              key: 'rating',             items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Blog',                key: 'blog',               items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Help Support',        key: 'helpSupport',        items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
//   { group: 'Bulk Mailing',        key: 'bulkMailing',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }] },
//   { group: 'Management Settings', key: 'managementSettings', items: [{ label: 'Add Staff', key: 'addStaff' }, { label: 'Permissions', key: 'permissions' }] },
// ]

// const TOTAL_PERMS = PERMISSION_GROUPS.reduce((a, g) => a + g.items.length, 0)

// const buildInitialState = () => {
//   const state = {}
//   PERMISSION_GROUPS.forEach(g => {
//     // enable alag track karo
//     state[g.key] = { enable: false }
//     g.items.forEach(item => { state[g.key][item.key] = false })
//   })
//   return state
// }

// const mergePermissions = (serverPerms) => {
//   const base = buildInitialState()
//   if (!serverPerms) return base
//   PERMISSION_GROUPS.forEach(g => {
//     if (serverPerms[g.key]) {
//       // enable merge karo
//       if (typeof serverPerms[g.key].enable === 'boolean') {
//         base[g.key].enable = serverPerms[g.key].enable
//       }
//       g.items.forEach(item => {
//         if (typeof serverPerms[g.key][item.key] === 'boolean') {
//           base[g.key][item.key] = serverPerms[g.key][item.key]
//         }
//       })
//     }
//   })
//   return base
// }

// const countSelected = (perms) =>
//   Object.values(perms).flatMap(g => Object.values(g)).filter(Boolean).length

// const ACTION_COLORS = {
//   view:   { bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' },
//   add:    { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
//   edit:   { bg: '#fefce8', color: '#92400e', border: '#fde68a' },
//   delete: { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
// }

// const getActionStyle = (key) => {
//   if (key === 'view')                              return ACTION_COLORS.view
//   if (key === 'add' || key === 'addStaff' || key === 'permissions') return ACTION_COLORS.add
//   if (key === 'edit')                              return ACTION_COLORS.edit
//   if (key === 'delete')                            return ACTION_COLORS.delete
//   return { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' }
// }

// const Permissions = () => {
//   const [roles, setRoles]                 = useState([])
//   const [savedPermsMap, setSavedPermsMap] = useState({})
//   const [selectedRole, setSelectedRole]   = useState(null)
//   const [permissions, setPermissions]     = useState(buildInitialState)
//   const [saving, setSaving]               = useState(false)
//   const [toast, setToast]                 = useState(null)

//   const showToast = (msg, type = 'success') => {
//     setToast({ msg, type })
//     setTimeout(() => setToast(null), 3000)
//   }

//   useEffect(() => {
//     const init = async () => {
//       try {
//         const res = await axios.get(`${Url}/role`)
//         const roleList = res.data || []
//         setRoles(roleList)
//         if (roleList.length === 0) return

//         const results = await Promise.allSettled(
//           roleList.map(r =>
//             axios.get(`${Url}/permissions/${r._id.toString()}`)
//               .then(res => ({ roleId: r._id.toString(), perms: res.data?.data?.permissions || null }))
//               .catch(() => ({ roleId: r._id.toString(), perms: null }))
//           )
//         )

//         const map = {}
//         results.forEach(result => {
//           if (result.status === 'fulfilled' && result.value.perms) {
//             map[result.value.roleId] = result.value.perms
//           }
//         })
//         setSavedPermsMap(map)

//         const firstRole = roleList[0]
//         setSelectedRole(firstRole)
//         setPermissions(mergePermissions(map[firstRole._id.toString()] || null))
//       } catch (err) {
//         console.error('Init error:', err)
//       }
//     }
//     init()
//   }, [])

//   const handleRoleSelect = (role) => {
//     const key = role._id.toString()
//     setSelectedRole(role)
//     setPermissions(mergePermissions(savedPermsMap[key] || null))
//   }

//   // ── Enable toggle — sirf group ka enable ─────────────────────
//   const toggleEnable = (groupKey) => {
//     setPermissions(prev => ({
//       ...prev,
//       [groupKey]: { ...prev[groupKey], enable: !prev[groupKey].enable },
//     }))
//   }

//   // ── Action item toggle ────────────────────────────────────────
//   const toggleItem = (groupKey, itemKey) => {
//     setPermissions(prev => ({
//       ...prev,
//       [groupKey]: { ...prev[groupKey], [itemKey]: !prev[groupKey][itemKey] },
//     }))
//   }

//   const selectAll = (val) => {
//     const state = {}
//     PERMISSION_GROUPS.forEach(g => {
//       state[g.key] = { enable: val }
//       g.items.forEach(item => { state[g.key][item.key] = val })
//     })
//     setPermissions(state)
//   }

//   const isGroupEnabled  = (groupKey) => permissions[groupKey]?.enable === true
//   const isAnyItemChecked = (groupKey, items) => items.some(i => permissions[groupKey][i.key])

//   const totalSelected = () => countSelected(permissions)
//   const hasExisting = selectedRole ? !!savedPermsMap[selectedRole._id.toString()] : false

//   const handleSubmit = async () => {
//     if (!selectedRole) return showToast('Role select karein!', 'error')
//     setSaving(true)
//     try {
//       const payload = { roleId: selectedRole._id, roleName: selectedRole.role, permissions }
//       await axios.post(`${Url}/permissions`, payload)
//       setSavedPermsMap(prev => ({ ...prev, [selectedRole._id.toString()]: permissions }))
//       showToast(`"${selectedRole.role}" ki permissions ${hasExisting ? 'update' : 'save'} ho gayi! ✓`)
//     } catch (err) {
//       showToast('Error aaya, dobara try karein!', 'error')
//     } finally {
//       setSaving(false)
//     }
//   }

//   const handleDelete = async () => {
//     if (!selectedRole) return
//     if (!window.confirm(`"${selectedRole.role}" ki permissions delete karein?`)) return
//     try {
//       await axios.delete(`${Url}/permissions/${selectedRole._id}`)
//       setSavedPermsMap(prev => {
//         const updated = { ...prev }
//         delete updated[selectedRole._id.toString()]
//         return updated
//       })
//       setPermissions(buildInitialState())
//       showToast(`"${selectedRole.role}" ki permissions delete ho gayi!`, 'error')
//     } catch (err) {
//       showToast('Delete mein error!', 'error')
//     }
//   }

//   return (
//     <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', background: '#f8fafc' }}>

//       {toast && (
//         <div style={{
//           position: 'fixed', top: 20, right: 20, zIndex: 9999,
//           padding: '12px 20px', borderRadius: 10, fontSize: 13, fontWeight: 600,
//           background: toast.type === 'error' ? '#fef2f2' : '#f0fdf4',
//           color: toast.type === 'error' ? '#dc2626' : '#16a34a',
//           border: `1px solid ${toast.type === 'error' ? '#fecaca' : '#bbf7d0'}`,
//           boxShadow: '0 4px 12px rgba(0,0,0,.1)',
//         }}>
//           {toast.type === 'error' ? '❌' : '✅'} {toast.msg}
//         </div>
//       )}

//       {/* LEFT — Roles */}
//       <div style={{ width: 240, background: 'white', borderRight: '1px solid #e2e8f0', padding: '24px 0', flexShrink: 0, overflowY: 'auto' }}>
//         <div style={{ padding: '0 16px 16px', borderBottom: '1px solid #f1f5f9' }}>
//           <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}>👥 All Roles</h3>
//           <p style={{ margin: '4px 0 0', fontSize: 11, color: '#94a3b8' }}>{roles.length} roles total</p>
//         </div>
//         <div style={{ padding: '8px 0' }}>
//           {roles.length === 0 ? (
//             <p style={{ padding: '12px 16px', fontSize: 13, color: '#94a3b8' }}>Loading...</p>
//           ) : (
//             roles.map(r => {
//               const key      = r._id.toString()
//               const isActive = selectedRole?._id.toString() === key
//               const isSet    = !!savedPermsMap[key]
//               const setCount = isSet ? countSelected(mergePermissions(savedPermsMap[key])) : 0
//               return (
//                 <div key={key} onClick={() => handleRoleSelect(r)}
//                   style={{ padding: '10px 16px', cursor: 'pointer', background: isActive ? '#eff6ff' : 'transparent', borderLeft: `3px solid ${isActive ? '#1e40af' : 'transparent'}`, transition: 'all 0.15s' }}>
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                     <span style={{ fontSize: 13, fontWeight: isActive ? 700 : 500, color: isActive ? '#1e40af' : '#334155', textTransform: 'capitalize' }}>
//                       {r.role}
//                     </span>
//                     <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 10, fontWeight: 600, background: isSet ? '#f0fdf4' : '#fef9c3', color: isSet ? '#16a34a' : '#92400e', border: `1px solid ${isSet ? '#bbf7d0' : '#fde68a'}` }}>
//                       {isSet ? '✓ Set' : 'Pending'}
//                     </span>
//                   </div>
//                   {isSet && (
//                     <div style={{ marginTop: 6 }}>
//                       <div style={{ height: 4, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
//                         <div style={{ height: '100%', width: `${(setCount / TOTAL_PERMS) * 100}%`, background: '#1e40af', borderRadius: 4 }} />
//                       </div>
//                       <span style={{ fontSize: 10, color: '#94a3b8', marginTop: 2, display: 'block' }}>
//                         {setCount}/{TOTAL_PERMS} permissions
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               )
//             })
//           )}
//         </div>
//       </div>

//       {/* RIGHT — Editor */}
//       <div style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>

//         <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <div>
//             <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1e293b' }}>
//               {selectedRole
//                 ? <>Permissions — <span style={{ color: '#1e40af', textTransform: 'capitalize' }}>{selectedRole.role}</span></>
//                 : 'Permissions'}
//             </h2>
//             <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
//               {hasExisting ? '✏️ Edit mode — permissions pehle se set hain' : '🆕 Naye permissions set karein'}
//             </p>
//           </div>
//           {hasExisting && (
//             <span style={{ fontSize: 12, padding: '5px 14px', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 20, fontWeight: 600 }}>
//               ✓ Already Configured
//             </span>
//           )}
//         </div>

//         {/* Actions Bar */}
//         <div style={{ background: 'white', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,.05)' }}>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: '#64748b' }}>
//             <span style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{totalSelected()}</span>
//             <span>/ {TOTAL_PERMS} selected</span>
//             <div style={{ width: 100, height: 6, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
//               <div style={{ height: '100%', width: `${(totalSelected() / TOTAL_PERMS) * 100}%`, background: '#1e40af', borderRadius: 4, transition: 'width 0.2s' }} />
//             </div>
//           </div>
//           <div style={{ display: 'flex', gap: 8 }}>
//             <button onClick={() => selectAll(true)}
//               style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: 7, cursor: 'pointer' }}>
//               ✓ All
//             </button>
//             <button onClick={() => selectAll(false)}
//               style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: 7, cursor: 'pointer' }}>
//               ✕ None
//             </button>
//             {hasExisting && (
//               <button onClick={handleDelete}
//                 style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 7, cursor: 'pointer' }}>
//                 🗑 Delete
//               </button>
//             )}
//             <button onClick={handleSubmit} disabled={saving || !selectedRole}
//               style={{ padding: '6px 20px', fontSize: 12, fontWeight: 700, background: saving || !selectedRole ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 7, cursor: saving ? 'not-allowed' : 'pointer' }}>
//               {saving ? '⏳...' : hasExisting ? '✏️ Update' : '💾 Save'}
//             </button>
//           </div>
//         </div>

//         {/* Legend */}
//         <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
//           <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>Legend:</span>
//           {[
//             { label: '☑ Section Enable', bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
//             { label: 'View',   ...ACTION_COLORS.view },
//             { label: 'Add',    ...ACTION_COLORS.add },
//             { label: 'Edit',   ...ACTION_COLORS.edit },
//             { label: 'Delete', ...ACTION_COLORS.delete },
//           ].map(l => (
//             <span key={l.label} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, fontWeight: 600, background: l.bg, color: l.color, border: `1px solid ${l.border}` }}>
//               {l.label}
//             </span>
//           ))}
//         </div>

//         {!selectedRole ? (
//           <div style={{ textAlign: 'center', padding: 80, color: '#94a3b8' }}>
//             <div style={{ fontSize: 40, marginBottom: 12 }}>👈</div>
//             <p style={{ fontSize: 14 }}>Left side se koi role select karein</p>
//           </div>
//         ) : (
//           <>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
//               {PERMISSION_GROUPS.map(({ group, key: groupKey, items }) => {
//                 const enabled      = isGroupEnabled(groupKey)
//                 const anyChecked   = isAnyItemChecked(groupKey, items)
//                 return (
//                   <div key={groupKey} style={{
//                     background: 'white', borderRadius: 12,
//                     border: `1px solid ${enabled ? '#bfdbfe' : '#e2e8f0'}`,
//                     overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,.04)',
//                     opacity: enabled ? 1 : 0.7,
//                   }}>

//                     {/* ── Group Header — Enable checkbox ── */}
//                     <div style={{
//                       padding: '11px 14px',
//                       background: enabled ? '#eff6ff' : '#f8fafc',
//                       borderBottom: '1px solid #e2e8f0',
//                       display: 'flex', alignItems: 'center', gap: 10,
//                     }}>
//                       {/* Enable toggle */}
//                       <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', flex: 1 }}>
//                         <input
//                           type="checkbox"
//                           checked={enabled}
//                           onChange={() => toggleEnable(groupKey)}
//                           style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#1e40af' }}
//                         />
//                         <span style={{ fontSize: 13, fontWeight: 700, color: enabled ? '#1e40af' : '#1e293b' }}>
//                           {group}
//                         </span>
//                       </label>

//                       {/* Count badge */}
//                       <span style={{ fontSize: 10, color: enabled ? '#1e40af' : '#94a3b8', fontWeight: 600 }}>
//                         {anyChecked ? `${items.filter(i => permissions[groupKey][i.key]).length}/${items.length}` : '0/' + items.length}
//                       </span>
//                     </div>

//                     {/* ── Action Items — sirf tab dikhao jab enable ho ── */}
//                     <div style={{ padding: '10px 14px', display: 'flex', flexWrap: 'wrap', gap: 8, minHeight: 44 }}>
//                       {enabled ? (
//                         items.map(({ label, key: itemKey }) => {
//                           const checked = permissions[groupKey][itemKey]
//                           const s = getActionStyle(itemKey)
//                           return (
//                             <label key={itemKey}
//                               style={{
//                                 display: 'flex', alignItems: 'center', gap: 6,
//                                 padding: '5px 12px', borderRadius: 20, cursor: 'pointer',
//                                 background: checked ? s.bg : 'white',
//                                 border: `1.5px solid ${checked ? s.border : '#e2e8f0'}`,
//                                 transition: 'all 0.15s',
//                               }}>
//                               <input
//                                 type="checkbox"
//                                 checked={checked}
//                                 onChange={() => toggleItem(groupKey, itemKey)}
//                                 style={{ width: 13, height: 13, cursor: 'pointer', accentColor: s.color }}
//                               />
//                               <span style={{ fontSize: 12, fontWeight: checked ? 700 : 400, color: checked ? s.color : '#94a3b8', whiteSpace: 'nowrap' }}>
//                                 {label}
//                               </span>
//                             </label>
//                           )
//                         })
//                       ) : (
//                         <span style={{ fontSize: 12, color: '#cbd5e1', fontStyle: 'italic' }}>
//                           Section enable karo phir actions set karein
//                         </span>
//                       )}
//                     </div>
//                   </div>
//                 )
//               })}
//             </div>

//             <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
//               {hasExisting && (
//                 <button onClick={handleDelete}
//                   style={{ padding: '10px 24px', fontSize: 14, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, cursor: 'pointer' }}>
//                   🗑 Delete Permissions
//                 </button>
//               )}
//               <button onClick={handleSubmit} disabled={saving || !selectedRole}
//                 style={{ padding: '10px 32px', fontSize: 14, fontWeight: 700, background: saving ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 8, cursor: saving ? 'not-allowed' : 'pointer' }}>
//                 {saving ? '⏳ Saving...' : hasExisting ? '✏️ Update Permissions' : '💾 Save Permissions'}
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   )
// }

// export default Permissions







import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Url } from 'src/url/url'

const PERMISSION_GROUPS = [
  { group: 'Dashboard',           key: 'dashboard',          items: [{ label: 'View', key: 'view' }] },
  { group: 'New Projects',        key: 'newProjects',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Running Projects',    key: 'runningProjects',    items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Complete Projects',   key: 'completeProjects',   items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Refund Project',      key: 'refundProject',      items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Team',                key: 'team',               items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Services',            key: 'services',           items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Category',            key: 'category',           items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Subcategory',         key: 'subcategory',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Package',             key: 'package',            items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Project',             key: 'project',            items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Combo Services',      key: 'comboServices',      items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Client',              key: 'client',             items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Chat',                key: 'chat',               items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Coupon',              key: 'coupon',             items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Icons Format',        key: 'iconsFormat',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }, { label: 'Bulk Email Images', key: 'bulkEmailImages' }] },
  { group: 'Staff Role',          key: 'staffRole',          items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Rating',              key: 'rating',             items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Blog',                key: 'blog',               items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Help Support',        key: 'helpSupport',        items: [{ label: 'View', key: 'view' }, { label: 'Delete', key: 'delete' }] },
  { group: 'Bulk Mailing',        key: 'bulkMailing',        items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }] },
  { group: 'Management Settings', key: 'managementSettings', items: [{ label: 'Add Staff', key: 'addStaff' }, { label: 'Permissions', key: 'permissions' }] },
  { group: 'StaffHelpSupport', key: 'StaffHelpSupport',   items: [{ label: 'View', key: 'view' }, { label: 'Add', key: 'add' }, { label: 'Edit', key: 'edit' }, { label: 'Delete', key: 'delete' }] },
]

const TOTAL_PERMS = PERMISSION_GROUPS.reduce((a, g) => a + g.items.length, 0)

const buildInitialState = () => {
  const state = {}
  PERMISSION_GROUPS.forEach(g => {
    state[g.key] = { enable: false }
    g.items.forEach(item => { state[g.key][item.key] = false })
  })
  return state
}

const mergePermissions = (serverPerms) => {
  const base = buildInitialState()
  if (!serverPerms) return base
  PERMISSION_GROUPS.forEach(g => {
    if (serverPerms[g.key]) {
      if (typeof serverPerms[g.key].enable === 'boolean') {
        base[g.key].enable = serverPerms[g.key].enable
      }
      g.items.forEach(item => {
        if (typeof serverPerms[g.key][item.key] === 'boolean') {
          base[g.key][item.key] = serverPerms[g.key][item.key]
        }
      })
    }
  })
  return base
}

const countSelected = (perms) =>
  Object.values(perms).flatMap(g => Object.values(g)).filter(Boolean).length

const ACTION_COLORS = {
  view:   { bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' },
  add:    { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
  edit:   { bg: '#fefce8', color: '#92400e', border: '#fde68a' },
  delete: { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
}

const getActionStyle = (key) => {
  if (key === 'view')                                                  return ACTION_COLORS.view
  if (key === 'add' || key === 'addStaff' || key === 'permissions')   return ACTION_COLORS.add
  if (key === 'edit')                                                  return ACTION_COLORS.edit
  if (key === 'delete')                                                return ACTION_COLORS.delete
  return { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' }
}


const Permissions = () => {
  const [roles, setRoles]                 = useState([])
  const [savedPermsMap, setSavedPermsMap] = useState({})
  const [selectedRole, setSelectedRole]   = useState(null)
  const [permissions, setPermissions]     = useState(buildInitialState)
  const [saving, setSaving]               = useState(false)
  const [toast, setToast]                 = useState(null)

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type })
    setTimeout(() => setToast(null), 3000)
  }

  useEffect(() => {
    const init = async () => {
      try {
        const res = await axios.get(`${Url}/role`)
        const roleList = res.data || []
        setRoles(roleList)
        if (roleList.length === 0) return

        const results = await Promise.allSettled(
          roleList.map(r =>
            axios.get(`${Url}/permissions/${r._id.toString()}`)
              .then(res => ({ roleId: r._id.toString(), perms: res.data?.data?.permissions || null }))
              .catch(() => ({ roleId: r._id.toString(), perms: null }))
          )
        )

        const map = {}
        results.forEach(result => {
          if (result.status === 'fulfilled' && result.value.perms) {
            map[result.value.roleId] = result.value.perms
          }
        })
        setSavedPermsMap(map)

        const firstRole = roleList[0]
        setSelectedRole(firstRole)
        setPermissions(mergePermissions(map[firstRole._id.toString()] || null))
      } catch (err) {
        console.error('Initialization error:', err)
      }
    }
    init()
  }, [])

  const handleRoleSelect = (role) => {
    const key = role._id.toString()
    setSelectedRole(role)
    setPermissions(mergePermissions(savedPermsMap[key] || null))
  }

  const toggleEnable = (groupKey) => {
    setPermissions(prev => ({
      ...prev,
      [groupKey]: { ...prev[groupKey], enable: !prev[groupKey].enable },
    }))
  }

  const toggleItem = (groupKey, itemKey) => {
    setPermissions(prev => ({
      ...prev,
      [groupKey]: { ...prev[groupKey], [itemKey]: !prev[groupKey][itemKey] },
    }))
  }

  const selectAll = (val) => {
    const state = {}
    PERMISSION_GROUPS.forEach(g => {
      state[g.key] = { enable: val }
      g.items.forEach(item => { state[g.key][item.key] = val })
    })
    setPermissions(state)
  }

  const isGroupEnabled   = (groupKey) => permissions[groupKey]?.enable === true
  const isAnyItemChecked = (groupKey, items) => items.some(i => permissions[groupKey][i.key])

  const totalSelected = () => countSelected(permissions)
  const hasExisting = selectedRole ? !!savedPermsMap[selectedRole._id.toString()] : false

  const handleSubmit = async () => {
    if (!selectedRole) return showToast('Please select a role.', 'error')
    setSaving(true)
    try {
      const payload = { roleId: selectedRole._id, roleName: selectedRole.role, permissions }
      await axios.post(`${Url}/permissions`, payload)
      setSavedPermsMap(prev => ({ ...prev, [selectedRole._id.toString()]: permissions }))
      showToast(`Permissions for "${selectedRole.role}" ${hasExisting ? 'updated' : 'saved'} successfully. ✓`)
    } catch (err) {
      showToast('An error occurred. Please try again.', 'error')
    } finally {
      setSaving(false)
    }
  }

  const handleDelete = async () => {
    if (!selectedRole) return
    if (!window.confirm(`Delete permissions for "${selectedRole.role}"?`)) return
    try {
      await axios.delete(`${Url}/permissions/${selectedRole._id}`)
      setSavedPermsMap(prev => {
        const updated = { ...prev }
        delete updated[selectedRole._id.toString()]
        return updated
      })
      setPermissions(buildInitialState())
      showToast(`Permissions for "${selectedRole.role}" have been deleted.`, 'error')
    } catch (err) {
      showToast('Failed to delete permissions. Please try again.', 'error')
    }
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: 'system-ui, sans-serif', background: '#f8fafc' }}>

      {toast && (
        <div style={{
          position: 'fixed', top: 20, right: 20, zIndex: 9999,
          padding: '12px 20px', borderRadius: 10, fontSize: 13, fontWeight: 600,
          background: toast.type === 'error' ? '#fef2f2' : '#f0fdf4',
          color: toast.type === 'error' ? '#dc2626' : '#16a34a',
          border: `1px solid ${toast.type === 'error' ? '#fecaca' : '#bbf7d0'}`,
          boxShadow: '0 4px 12px rgba(0,0,0,.1)',
        }}>
          {toast.type === 'error' ? '❌' : '✅'} {toast.msg}
        </div>
      )}

      {/* LEFT — Roles */}
      <div style={{ width: 240, background: 'white', borderRight: '1px solid #e2e8f0', padding: '24px 0', flexShrink: 0, overflowY: 'auto' }}>
        <div style={{ padding: '0 16px 16px', borderBottom: '1px solid #f1f5f9' }}>
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}>👥 All Roles</h3>
          <p style={{ margin: '4px 0 0', fontSize: 11, color: '#94a3b8' }}>{roles.length} roles total</p>
        </div>
        <div style={{ padding: '8px 0' }}>
          {roles.length === 0 ? (
            <p style={{ padding: '12px 16px', fontSize: 13, color: '#94a3b8' }}>Loading...</p>
          ) : (
            roles.map(r => {
              const key      = r._id.toString()
              const isActive = selectedRole?._id.toString() === key
              const isSet    = !!savedPermsMap[key]
              const setCount = isSet ? countSelected(mergePermissions(savedPermsMap[key])) : 0
              return (
                <div key={key} onClick={() => handleRoleSelect(r)}
                  style={{ padding: '10px 16px', cursor: 'pointer', background: isActive ? '#eff6ff' : 'transparent', borderLeft: `3px solid ${isActive ? '#1e40af' : 'transparent'}`, transition: 'all 0.15s' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 13, fontWeight: isActive ? 700 : 500, color: isActive ? '#1e40af' : '#334155', textTransform: 'capitalize' }}>
                      {r.role}
                    </span>
                    <span style={{ fontSize: 10, padding: '2px 7px', borderRadius: 10, fontWeight: 600, background: isSet ? '#f0fdf4' : '#fef9c3', color: isSet ? '#16a34a' : '#92400e', border: `1px solid ${isSet ? '#bbf7d0' : '#fde68a'}` }}>
                      {isSet ? '✓ Set' : 'Pending'}
                    </span>
                  </div>
                  {isSet && (
                    <div style={{ marginTop: 6 }}>
                      <div style={{ height: 4, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: `${(setCount / TOTAL_PERMS) * 100}%`, background: '#1e40af', borderRadius: 4 }} />
                      </div>
                      <span style={{ fontSize: 10, color: '#94a3b8', marginTop: 2, display: 'block' }}>
                        {setCount}/{TOTAL_PERMS} permissions
                      </span>
                    </div>
                  )}
                </div>
              )
            })
          )}
        </div>
      </div>

      {/* RIGHT — Editor */}
      <div style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>

        <div style={{ marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1e293b' }}>
              {selectedRole
                ? <>Permissions — <span style={{ color: '#1e40af', textTransform: 'capitalize' }}>{selectedRole.role}</span></>
                : 'Permissions'}
            </h2>
            <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>
              {hasExisting ? '✏️ Edit mode — permissions are already configured' : '🆕 Configure new permissions'}
            </p>
          </div>
          {hasExisting && (
            <span style={{ fontSize: 12, padding: '5px 14px', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0', borderRadius: 20, fontWeight: 600 }}>
              ✓ Already Configured
            </span>
          )}
        </div>

        {/* Actions Bar */}
        <div style={{ background: 'white', borderRadius: 12, padding: '12px 16px', marginBottom: 20, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,.05)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: '#64748b' }}>
            <span style={{ fontWeight: 700, color: '#1e293b', fontSize: 15 }}>{totalSelected()}</span>
            <span>/ {TOTAL_PERMS} selected</span>
            <div style={{ width: 100, height: 6, background: '#e2e8f0', borderRadius: 4, overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${(totalSelected() / TOTAL_PERMS) * 100}%`, background: '#1e40af', borderRadius: 4, transition: 'width 0.2s' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => selectAll(true)}
              style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: 7, cursor: 'pointer' }}>
              ✓ Select All
            </button>
            <button onClick={() => selectAll(false)}
              style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#f8fafc', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: 7, cursor: 'pointer' }}>
              ✕ Clear All
            </button>
            {hasExisting && (
              <button onClick={handleDelete}
                style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 7, cursor: 'pointer' }}>
                🗑 Delete
              </button>
            )}
            <button onClick={handleSubmit} disabled={saving || !selectedRole}
              style={{ padding: '6px 20px', fontSize: 12, fontWeight: 700, background: saving || !selectedRole ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 7, cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? '⏳ Saving...' : hasExisting ? ' Update' : ' Save'}
            </button>
          </div>
        </div>

        {/* Legend */}
        <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>Legend:</span>
          {[
            { label: '☑ Section Enable', bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
            { label: 'View',   ...ACTION_COLORS.view },
            { label: 'Add',    ...ACTION_COLORS.add },
            { label: 'Edit',   ...ACTION_COLORS.edit },
            { label: 'Delete', ...ACTION_COLORS.delete },
          ].map(l => (
            <span key={l.label} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, fontWeight: 600, background: l.bg, color: l.color, border: `1px solid ${l.border}` }}>
              {l.label}
            </span>
          ))}
        </div>

        {!selectedRole ? (
          <div style={{ textAlign: 'center', padding: 80, color: '#94a3b8' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>👈</div>
            <p style={{ fontSize: 14 }}>Please select a role from the left panel</p>
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
              {PERMISSION_GROUPS.map(({ group, key: groupKey, items }) => {
                const enabled    = isGroupEnabled(groupKey)
                const anyChecked = isAnyItemChecked(groupKey, items)
                return (
                  <div key={groupKey} style={{
                    background: 'white', borderRadius: 12,
                    border: `1px solid ${enabled ? '#bfdbfe' : '#e2e8f0'}`,
                    overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,.04)',
                    opacity: enabled ? 1 : 0.7,
                  }}>

                    {/* Group Header */}
                    <div style={{
                      padding: '11px 14px',
                      background: enabled ? '#eff6ff' : '#f8fafc',
                      borderBottom: '1px solid #e2e8f0',
                      display: 'flex', alignItems: 'center', gap: 10,
                    }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', flex: 1 }}>
                        <input
                          type="checkbox"
                          checked={enabled}
                          onChange={() => toggleEnable(groupKey)}
                          style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#1e40af' }}
                        />
                        <span style={{ fontSize: 13, fontWeight: 700, color: enabled ? '#1e40af' : '#1e293b' }}>
                          {group}
                        </span>
                      </label>

                      <span style={{ fontSize: 10, color: enabled ? '#1e40af' : '#94a3b8', fontWeight: 600 }}>
                        {anyChecked ? `${items.filter(i => permissions[groupKey][i.key]).length}/${items.length}` : '0/' + items.length}
                      </span>
                    </div>

                    {/* Action Items */}
                    <div style={{ padding: '10px 14px', display: 'flex', flexWrap: 'wrap', gap: 8, minHeight: 44 }}>
                      {enabled ? (
                        items.map(({ label, key: itemKey }) => {
                          const checked = permissions[groupKey][itemKey]
                          const s = getActionStyle(itemKey)
                          return (
                            <label key={itemKey}
                              style={{
                                display: 'flex', alignItems: 'center', gap: 6,
                                padding: '5px 12px', borderRadius: 20, cursor: 'pointer',
                                background: checked ? s.bg : 'white',
                                border: `1.5px solid ${checked ? s.border : '#e2e8f0'}`,
                                transition: 'all 0.15s',
                              }}>
                              <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => toggleItem(groupKey, itemKey)}
                                style={{ width: 13, height: 13, cursor: 'pointer', accentColor: s.color }}
                              />
                              <span style={{ fontSize: 12, fontWeight: checked ? 700 : 400, color: checked ? s.color : '#94a3b8', whiteSpace: 'nowrap' }}>
                                {label}
                              </span>
                            </label>
                          )
                        })
                      ) : (
                        <span style={{ fontSize: 12, color: '#cbd5e1', fontStyle: 'italic' }}>
                          Enable this section to configure actions
                        </span>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>

            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              {hasExisting && (
                <button onClick={handleDelete}
                  style={{ padding: '10px 24px', fontSize: 14, fontWeight: 600, background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, cursor: 'pointer' }}>
                  🗑 Delete Permissions
                </button>
              )}
              <button onClick={handleSubmit} disabled={saving || !selectedRole}
                style={{ padding: '10px 32px', fontSize: 14, fontWeight: 700, background: saving ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 8, cursor: saving ? 'not-allowed' : 'pointer' }}>
                {saving ? '⏳ Saving...' : hasExisting ? '✏️ Update Permissions' : '💾 Save Permissions'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Permissions